import {
  pageSet,
  flightRequery,
  failed,
  loading,
  gatewayIntent,
  gatewayProcess,
  vendorLoaded,
  vendorSelect,
  historyLoaded,
  historySelected,
  historyDetailsLoaded,
  orderReset,
  flightCancel,
  intentFinal,
} from "./orderSlice";
import {
  requeryFlightUrl,
  gatewayIntentUrl,
  gatewayProcessUrl,
  vendorUrl,
  historyUrl,
  flightHistoryDetailUrl,
  flightCancelUrl,
  paymentVerifyUrl,
  paymentIntentUrl,
  transactionStatusUrl,
  simulateWebhookUrl,
} from "./apis";
import Axios from "axios";
import { tokenConfig } from "../actions";

export const requeryFlight =
  (data: any, func: any, errFunc: any) => (dispatch: any) => {
    dispatch(loading());
    Axios.post(requeryFlightUrl, data)
      .then((res) => {
        dispatch(flightRequery(res.data));
        func(res.data);
      })
      .catch((err) => {
        dispatch(failed(err.response));
        errFunc(err.response.data);
      });
  };
export const getFlightDetails = (ref: any, errFunc: any) => (dispatch: any) => {
  dispatch(loading());
  Axios.get(flightHistoryDetailUrl + ref, tokenConfig())
    .then((res) => {
      dispatch(historyDetailsLoaded(res.data));
    })
    .catch((err) => {
      dispatch(failed(err.response));
      errFunc(err.response.data);
    });
};
export const loadHistory = () => (dispatch: any) => {
  dispatch(loading());
  Axios.get(historyUrl, tokenConfig())
    .then((res) => {
      dispatch(historyLoaded(res.data));
    })
    .catch((err) => {
      dispatch(failed(err.response));
    });
};

export const intentGateway =
  (data: any, func: any, errFunc: any) => (dispatch: any) => {
    dispatch(loading());
    Axios.post(gatewayIntentUrl, data)
      .then((res) => {
        dispatch(gatewayIntent(res.data));

        func(res.data);
      })
      .catch((err) => {
        dispatch(failed(err.response));
        errFunc(err.response.data);
      });
  };
export const paymentIntiation =
  (data: any, func: any, errFunc: any) => (dispatch: any) => {
    dispatch(loading());
    Axios.post(paymentIntentUrl, data)
      .then((res) => {
        // intent_final (createIntent) responds with `{ model: transaction }`
        // — every consumer of intentFinal (PaymentForm, Authorize) reads
        // fields like .systemRef/.amount straight off it, so unwrap here
        // rather than leaving the transaction nested under .model.
        const transaction = res.data?.model ?? res.data;
        dispatch(intentFinal(transaction));

        func(transaction);
      })
      .catch((err) => {
        dispatch(failed(err.response));
        errFunc(err.response.data);
      });
  };
export const processGateway =
  (data: any, func: any, errFunc: any) => (dispatch: any) => {
    dispatch(loading());
    Axios.post(gatewayProcessUrl, data)
      .then((res) => {
        dispatch(gatewayProcess(res.data));
        func(res.data);
      })
      .catch((err) => {
        dispatch(failed(err.response));
        errFunc(err.response.data);
      });
  };
export const verifyPayment =
  (data: any, func: any, errFunc: any) => (dispatch: any) => {
    dispatch(loading());
    Axios.post(paymentVerifyUrl, data)
      .then((res) => {
        dispatch(gatewayProcess(res.data));
        func(res.data);
      })
      .catch((err) => {
        dispatch(failed(err.response));
        errFunc(err.response.data);
      });
  };
// Deliberately doesn't dispatch loading()/failed() — this fires on a poll
// interval and shouldn't flip the shared `state.order.loading` flag other
// buttons on the page key off (that would make e.g. "Pay now" flicker as if
// disabled every few seconds while we're just checking status).
export const getTransactionStatus =
  (systemRef: string, func: any, errFunc: any) => () => {
    Axios.get(transactionStatusUrl + systemRef)
      .then((res) => {
        func(res.data);
      })
      .catch((err) => {
        errFunc(err);
      });
  };

// Dev-only — the backend rejects this outside non-production environments.
// Lets local dev replay a webhook event Paystack/Stripe can't actually
// deliver to localhost.
export const simulateWebhook =
  (data: { systemRef: string; vendor: "paystack" | "stripe"; status?: "success" | "failed" }, func: any, errFunc: any) =>
  () => {
    Axios.post(simulateWebhookUrl, data)
      .then((res) => {
        func(res.data);
      })
      .catch((err) => {
        errFunc(err);
      });
  };

export const loadVendor = () => (dispatch: any) => {
  dispatch(loading());
  Axios.get(vendorUrl)
    .then((res) => {
      dispatch(vendorLoaded(res.data));
    })
    .catch((err) => {
      dispatch(failed(err.response));
    });
};
export const cancelFlight =
  (ref: string, func: any, errFunc: any) => (dispatch: any) => {
    dispatch(loading());
    Axios.get(flightCancelUrl + ref, tokenConfig())
      .then((res) => {
        dispatch(flightCancel(res.data));
        func(res.data);
      })
      .catch((err) => {
        dispatch(failed(err.response));
        errFunc();
      });
  };

export const setPage = (page: any) => (dispatch: any) => {
  dispatch(pageSet(page));
};

export const setVendor = (page: any) => (dispatch: any) => {
  dispatch(vendorSelect(page));
};

export const setHistory = (page: any) => (dispatch: any) => {
  dispatch(historySelected(page));
};

export const resetOrder = () => (dispatch: any) => {
  dispatch(orderReset());
};
